import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useState } from "react";
import "../../assets/css/modal.css";
import { useSelector } from "react-redux";
import axios from "axios";
import { Modal } from "react-bootstrap";

function TeamModal({ handleClose, show, reloadList }) {
  useTranslation();
  const auth = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (email === "") {
      formIsValid = false;
      errors["email"] = "Please enter an email address.";
    } else {
      const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email)) {
        formIsValid = false;
        errors["email"] = "Please enter a valid email address.";
      }
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    try {
      if (validateForm()) {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        const workspace_id = auth.workspace_id;
        const body = JSON.stringify({ email, workspace_id });
        const res = await axios.post("/api/team/sendemail", body, config);
        if (res.data.msg === "success") {
          setEmail("");
          setErrors({});
          handleClose();
          reloadList();
        } else if (res.data.user === true) {
          setErrors({ email: res.data.msg });
        } else if (res.data.msg === "plan_limit") {
          const planName = res.data.plan === 'pro' ? 'Pro' : res.data.plan === 'team' ? 'Team' : 'Free';
          const upgradeMsg = res.data.next_plan
            ? ` Upgrade to ${res.data.next_plan === 'pro' ? 'Pro' : 'Team'} for up to ${res.data.next_limit} users.`
            : '';
          setErrors({
            email: `You've reached the ${res.data.limit}-user limit on the ${planName} plan.${upgradeMsg}`,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose_ = () => {
    setEmail("");
    setErrors({});
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose_}
      dialogClassName="add-New-tag-popup-box-container"
      centered
    >
      {/* Header */}
      <div className="pm-header">
        <h3 className="pm-title">{tr("Invite Member")}</h3>
        <button className="pm-close" onClick={handleClose_} aria-label={tr("Close")}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M1 1l12 12M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="pm-body">
        <div className="pm-field">
          <label className="pm-label">{tr("Email address")}</label>
          <input
            className="pm-input"
            type="email"
            placeholder={tr("e.g. jane@company.com")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          />
          {errors.email && (
            <span className="pm-error">{errors.email}</span>
          )}
        </div>
        <p style={{ fontSize: 13, color: "var(--ti-muted)", margin: 0 }}>{tr("An invitation email will be sent. The member can join after signing up.")} </p>
      </div>

      {/* Footer */}
      <div className="pm-footer">
        <button className="pm-btn-cancel" onClick={handleClose_}>{tr("Cancel")} </button>
        <button className="pm-btn-create" onClick={handleSubmit}>{tr("Send Invite")} </button>
      </div>
    </Modal>
  );
}

export default TeamModal;
